<header>
  <div *ngIf="isLoading" id="loading">
    <img src="../../../assets/images/icon_gier.png" alt="Carregando...">
  </div>

  <div class="top-header">
    <div class="botao-acessibilidade" (click)="contraste()"
      style="cursor: pointer; user-select: none; margin-left: 8px;">
      Alto contraste
    </div>
    <span (click)="contraste()" style="cursor: pointer; user-select: none; margin-left: 8px;">|</span>
    <div class="botao-acessibilidade" (click)="zoomIn()" style="cursor: pointer; user-select: none;">
      <i class="fa fa-plus-circle icones-acessibilidade" aria-hidden="true"></i>
    </div>
    <div class="botao-acessibilidade" (click)="zoomNormal()" style="cursor: pointer; user-select: none;">
      <i class="fa fa-square icones-acessibilidade" aria-hidden="true"></i>
    </div>
    <div class="botao-acessibilidade" (click)="zoomOut()" style="cursor: pointer; user-select: none;">
      <i class="fa fa-minus-circle icones-acessibilidade" aria-hidden="true"></i>
    </div>
  </div>

  <div class="mid-header">
    <div class="logo-title">
      <a [routerLink]="['/']" class="logo-link">
        <img [src]="logoPrefeitura" alt="Logo Prefeitura" class="logo-prefeitura" />
      </a>
      <h1 class="site-title">Portal Educacional</h1>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDarkDropdown"
        aria-controls="navbarNavDarkDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNavDarkDropdown">
        <ul class="navbar-nav spacing-nav">

          <li *ngFor="let menu of getParentMenus()" [ngClass]="hasSubMenus(menu) ? 'nav-item dropdown' : 'nav-item'">

            <ng-container *ngIf="hasSubMenus(menu); else singleMenu">
              <a class="nav-link dropdown-toggle" href="#" id="menu{{menu.seqFaixaNavegacao}}" role="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                {{ menu.dsctituloMenu }}
              </a>

              <ul class="dropdown-menu" [attr.aria-labelledby]="'menu' + menu.seqFaixaNavegacao">
                <li *ngFor="let submenu of getSubMenus(menu)">
                  <a *ngIf="submenu.dscUrl && isExternal(submenu.dscUrl)" class="dropdown-item" [href]="submenu.dscUrl"
                    target="_blank" rel="noopener">
                    {{ submenu.dsctituloMenu }}
                  </a>
                  <a *ngIf="submenu.dscUrl && !isExternal(submenu.dscUrl)" class="dropdown-item"
                    [routerLink]="[ normalizeInternalUrl(submenu.dscUrl) ]" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }" (click)="onLinkClick()">
                    {{ submenu.dsctituloMenu }}
                  </a>
                  <!-- sem link -->
                  <ng-template #noLink>
                    <span class="dropdown-item disabled">{{ submenu.dsctituloMenu }}</span>
                  </ng-template>
                </li>
              </ul>
            </ng-container>

            <ng-template #singleMenu>
              <a *ngIf="menu.dscUrl && isExternal(menu.dscUrl)" class="nav-link" [href]="menu.dscUrl" target="_blank"
                rel="noopener">
                {{ menu.dsctituloMenu }}
              </a>
              <a *ngIf="menu.dscUrl && !isExternal(menu.dscUrl)" class="nav-link"
                [routerLink]="[ normalizeInternalUrl(menu.dscUrl) ]" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" (click)="onLinkClick()">
                {{ menu.dsctituloMenu }}
              </a>
              <ng-template #noLinkMain>
                <span class="nav-link disabled">{{ menu.dsctituloMenu }}</span>
              </ng-template>
            </ng-template>

          </li>
        </ul>
      </div>
      <form class="d-flex ms-auto busca-container" (ngSubmit)="pesquisaNlWeb()">
        <div class="input-group">
          <input [(ngModel)]="pergunta" name="pergunta" type="search" class="form-control"
            placeholder="Digite sua pergunta..." required />
          <button class="btn btn-primary botao-pesquisa" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </form>
    </div>
  </nav>
</header>